var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 60,
    fill: "#F3E6F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.7917 54.1667C68.0658 54.1667 66.6667 55.5658 66.6667 57.2917V59.375C66.6667 61.1009 68.0658 62.5 69.7917 62.5H80.2083C81.9342 62.5 83.3333 61.1009 83.3333 59.375V57.2917C83.3333 55.5658 81.9342 54.1667 80.2083 54.1667H69.7917Z",
    fill: "#870091"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5417 58.4096C60.921 58.5567 59.2666 58.9743 58.0806 60.1603C56.25 61.9909 56.25 64.9372 56.25 70.8297V83.3297C56.25 89.2223 56.25 92.1686 58.0806 93.9991C59.9112 95.8297 62.8574 95.8297 68.75 95.8297H81.25C87.1426 95.8297 90.0888 95.8297 91.9194 93.9991C93.75 92.1686 93.75 89.2223 93.75 83.3297V70.8297C93.75 64.9372 93.75 61.9909 91.9194 60.1603C90.7334 58.9743 89.079 58.5567 86.4583 58.4096V59.375C86.4583 62.8268 83.6601 65.625 80.2083 65.625H69.7917C66.3399 65.625 63.5417 62.8268 63.5417 59.375V58.4096ZM82.3161 76.1423C82.947 75.5535 82.9811 74.5647 82.3923 73.9339C81.8035 73.303 80.8147 73.2689 80.1839 73.8577L72.3214 81.196L69.8161 78.8577C69.1853 78.2689 68.1965 78.303 67.6077 78.9339C67.0189 79.5647 67.053 80.5535 67.6839 81.1423L71.2553 84.4756C71.8556 85.0359 72.7872 85.0359 73.3876 84.4756L82.3161 76.1423Z",
    fill: "#870091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintHover);
export default __webpack_public_path__ + "static/media/Print-hover.dd4575c957a5d7dc40cc45545ee7af5b.svg";
export { ForwardRef as ReactComponent };